<template>
	<div class="hero-inner">
		<div class="content content-full">
			<div class="py-4 text-center">
				<div class="display-1 fw-bold text-danger">
					{{ title }}
				</div>
				<h1 class="fw-bold mt-5 mb-2">{{ errorHeader || 'Requested Page Cannot Be Found' }}</h1>
				<h2 class="fs-4 fw-medium text-muted mb-5">{{ description }}.</h2>
				<InertiaLink v-if="!hideBtn" class="btn btn-lg btn-alt-secondary" href="/">
					<i class="fa fa-arrow-left opacity-50 me-1"></i> Back to Home
				</InertiaLink>
			</div>
		</div>
	</div>
</template>

<script>
import GuestLayout from '../Layouts/GuestLayout'

export default {
	layout: GuestLayout,
	props: {
		status: Number,
		desc: String,
		hideBtn: Boolean
	},
	computed: {
		title() {
			return {
				503: '503',
				500: '500',
				404: '404',
				403: '403',
			}[this.status]
		},
		errorHeader(){
			return {
				503: 'Site Temporarily Down for Maintenance',
				500: 'Server Encountered an Internal Error',
				404: 'Requested Page Cannot Be Found',
				403: 'Access to This Page is Forbidden',
			}[this.status]
		},
		description() {
			return {
				503: 'Sorry, our site is temporarily unavailable for essential maintenance. Please try again shortly.',
				500: 'We are sorry but your request contains bad syntax and cannot be fulfilled.',
				404: 'We are sorry but the page you are looking for was not found.',
				403: 'We are sorry but you do not have permission to access this page.',
				1032: this.desc
			}[this.status]
		},
	},
}
</script>
